import { Link } from '@ps/web-shared-components';
import React from 'react';

import type { EventDynamicBanner, ImageFetchProps } from '../../../../model/types';
import BannerImage from '../../../BannerImage/BannerImage';

import styles from './Standard.scss';

const StandardEventDynamicBanner: React.FC<EventDynamicBanner & ImageFetchProps> = ({
  eventType,
  competition,
  event,
  image,
  priority
}) => (
  <Link
    className={styles.container}
    alias="sportsEvent"
    values={{ ...eventType, ...competition, ...event }}
  >
    <BannerImage image={image} priority={priority} />
    <h2>{event.eventName}</h2>
  </Link>
);

export default StandardEventDynamicBanner;
